import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Breadcrumbs, Grid, Button, makeStyles } from "@material-ui/core";
import { Search, PersonAdd } from "@material-ui/icons";
import { validarSoloUnPermiso } from "../../helpers/permisos";
import { CONTRATACIONES_PERMISOS } from "../../utils/permisos";
import { ContratacionesIngreso } from "./ContratacionesIngreso";
import { ContratacionesConsulta } from "./ContratacionesConsulta";
import { TabsContrataciones } from "./TabsContrataciones";

import { MENU_CONTRATACIONES } from "../../utils/constants";
import { desSeleccionarContrato, desSeleccionarPresupuesto, fetchPrepuestoContratos } from "../../actions/contrataciones/contrataciones";
import { fetchTipoEfectores } from "../../actions/tipoSubtipoEfectores";
import { BannerAfiliado } from '../afiliaciones/BannerAfiliado';
import { useLocation } from "react-router-dom";
import LoadingBeforeViewData from "../compartidos/LoadingBeforeViewData";
import { ButtonGeneric } from "../atomic/atoms/Buttons";
import { GModal } from "../atomic/organisms/GenericModal";
import { useFormNew } from "../../hooks/useFormNew";
import { required } from "../../helpers/validations/validators";
import { Buscador } from "../atomic/molecules/Buscador";
import { ValidatorForm } from "react-material-ui-form-validator";
import moment from "moment";
import { ValidatedDate } from "../atomic/atoms/DatePicker";
import { useContratos } from "../../hooks/useCases/useContratos";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  tabs: {
    marginTop: "1rem",
  },
  button: {
    textAlign: "center",
  },
}));

export const HomeContrataciones = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const location = useLocation();
  const contratos = useContratos();

  const { permisos: permisosUser } = useSelector((state) => state.auth);
  const { dataContrato, presupuesto } = useSelector((state) => state.contrataciones);
  const [idPresupuesto, setIdPresupuesto] = useState(location.state?.idPresupuesto)
  const { subtipoEfectores } = useSelector(
    (state) => state.tipoSubtipoEfectores
  );

  const [menu, setMenu] = useState(0);
  const [nuevo, setNuevo] = useState(false);
  const [openCopiar, setOpenCopiar] = useState(false);

  const { formValues, setearValor, reset } = useFormNew({
    fechaInicioVigencia: null,
    efectorCopy: null,
    efectorPaste: null,
  });
  
  useEffect(() => {
    dispatch(fetchTipoEfectores());
    dispatch(desSeleccionarContrato());
  }, [dispatch]);

  useEffect(() => {
    dispatch(desSeleccionarPresupuesto());
    if (idPresupuesto) {
      dispatch(fetchPrepuestoContratos(location.state?.idPresupuesto, setIdPresupuesto))
      setMenu(MENU_CONTRATACIONES.INGRESO)
    }
  }, [location.state])

  if (idPresupuesto && presupuesto === null) {
    return <LoadingBeforeViewData />
  }

  const BuscadorContrato = ({value, name, label}) => (
    <Buscador
      value={value}
      setValue={(val) => setearValor(name, val)}
      textProps={{ name }}
      label={label}
      endpoint={(param) => `EfectorFacturacion/Busqueda?parametros=${param}&todos=${true}`}
      noOptionText={"No se encuentran Contratos"}
      filterOptions={(contratos) => contratos.filter(({fechaBaja}) => fechaBaja === null || moment(fechaBaja) <= moment())}
      getOptionLabel={(option) => {
        const subTipoEfector = subtipoEfectores.find(
          (subTipoEfector) =>
            subTipoEfector.idSubTipoEfector ===
            option.idSubTipoEfector
        )?.descripcionSubTipoEfector;
        return `${option.razonSocial} ${option.cuit} - ${subTipoEfector} -  ${option.efectorDomicilio?.calle} ${option.efectorDomicilio?.nro}`;
      }}
      validations={[required]}
    />
  )

  const dataModal = [
    {
      component: (
        <ValidatedDate
          style={{ padding: "0 0.5em" }}
          value={formValues.fechaInicioVigencia}
          label="Fecha Inicio Vigencia"
          name="fechaInicioVigencia"
          onChange={(date) => setearValor("fechaInicioVigencia", moment(date))}
          fullWidth
          validations={[required]}
        />
      )
    },
    {
      component: (
        <BuscadorContrato value={formValues.efectorCopy} name="efectorCopy" label="Contrato de Origen" />
      )
    },
    {
      component: (
        <BuscadorContrato value={formValues.efectorPaste} name="efectorPaste" label="Contrato de Destino" />
      )
    }
  ]

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} styles={{ padding: 5 }}>
          <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
            {validarSoloUnPermiso(
              permisosUser,
              CONTRATACIONES_PERMISOS.CONSULTA
            ) && (
                <Button
                  color={
                    menu === MENU_CONTRATACIONES.CONSULTA ? "default" : "inherit"
                  }
                  onClick={(e) => {
                    setMenu(MENU_CONTRATACIONES.CONSULTA);
                    dispatch(desSeleccionarContrato());
                    dispatch(desSeleccionarPresupuesto());
                  }}
                >
                  <Search />
                  Consultar Contratos
                </Button>
              )}
            {validarSoloUnPermiso(
              permisosUser,
              CONTRATACIONES_PERMISOS.ADMINISTRACION
            ) && (
                <Button
                  color={
                    menu === MENU_CONTRATACIONES.INGRESO ? "default" : "inherit"
                  }
                  onClick={(e) => {
                    setMenu(MENU_CONTRATACIONES.INGRESO);
                    dispatch(desSeleccionarContrato());
                    dispatch(desSeleccionarPresupuesto());
                  }}
                >
                  <PersonAdd />
                  Ingreso / Modificación de Contratos
                </Button>
              )}
          </Breadcrumbs>
        </Grid>
        {menu === MENU_CONTRATACIONES.INGRESO && ( 
          <Grid item xs={12} style={{display: "flex", justifyContent: "flex-end"}}>
            <ButtonGeneric
              text="Copiar Contrato"
              onClick={() => setOpenCopiar(true)}
            />

            <GModal open={openCopiar} onClose={() => setOpenCopiar(false)} maxWidth="sm" title="Copiar Contratos">
              <Grid 
                container 
                spacing={2} 
                component={ValidatorForm} 
                onSubmit={() =>{ 
                  contratos.post.contratos.copyConvenios(formValues, () => {
                    setOpenCopiar();
                    reset();
                  })
                }}
              >
                {dataModal.map(({component}, index) => (
                  <Grid key={index} item xs={12}>
                    {component}
                  </Grid>
                ))}
                <Grid item xs={12} style={{display: "flex", justifyContent: "flex-end"}}>
                  <ButtonGeneric
                    text="Guardar"
                    type="submit"
                  />
                </Grid>
              </Grid>
            </GModal>
          </Grid>
        )}
        <Grid item xs={12}>
          <Grid
            container
            justify="center"
            className={classes.root}
          >
            {menu === MENU_CONTRATACIONES.CONSULTA && (
              <ContratacionesConsulta />
            )}
            {menu === MENU_CONTRATACIONES.INGRESO && (
              <ContratacionesIngreso
                nuevo={nuevo}
                setNuevo={setNuevo}
              />
            )}
            <Grid item xs={12}>
              {dataContrato && <BannerAfiliado contratos />}
            </Grid>
            <Grid item xs={12}>
              {dataContrato && <TabsContrataciones menu={menu} nuevo={nuevo} setNuevo={setNuevo} />}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
